export default __webpack_public_path__ + "static/media/logo16n.5e400998.png";